import type { Region } from './Region';

export class RegionResponse {
    public regionList?: Array<Region>;

    public constructor(props: Pick<RegionResponse, 'regionList'>) {
        Object.assign(this, props);
    }
}
